import { render, staticRenderFns } from "./CDServiceRevenueTable.vue?vue&type=template&id=5c12cf15&scoped=true&"
import script from "./CDServiceRevenueTable.vue?vue&type=script&lang=js&"
export * from "./CDServiceRevenueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12cf15",
  null
  
)

export default component.exports